// extracted by mini-css-extract-plugin
export default {"DetailPage":"DetailPage_DetailPage__kcXaj","DetailPage__Description":"DetailPage_DetailPage__Description__OyT0L","DetailPage__detailLink":"DetailPage_DetailPage__detailLink__ZaStc"};